<template>
  <section class="mb-0 auto-height" id="about">
      <!-- <div class="container"> -->
        <h3 class="text-center mb-0">關於時詣</h3>
        <!-- <button type="button" :class="'btn btn-secondary' + (display==='history'?' selected':'')" @mouseover="display='history'">歷史沿革</button>
        <button type="button" :class="'btn btn-secondary' + (display==='mission'?' selected':'')" @mouseover="display='mission'">服務宗旨</button> -->
        <div class="organizationGraphDiv">
          <!-- <img v-show="display==='history'" :src="history" class="organizationGraph" alt="歷史沿革">
          <img v-show="display==='mission'" :src="mission" class="organizationGraph" alt="服務宗旨"> -->
          <img src="about.jpg" class="organizationGraph" alt="關於時詣">
        </div>
      <!-- </div> -->
  </section>
</template>

<script>
export default {
  name: 'About',
  props: {
    history: String,
    mission: String
  },
  data() {
    return {
      display: 'history',
    }
  }
}
</script>

<style scoped>
.organizationGraphDiv {
  width: 100%;
  margin: 4vh auto;
}
.organizationGraph {
  max-width: 100%;
}
</style>